export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

// TimeOnly (C#) is represented as a string in "HH:mm[:ss]" format here
export type TimeOnlyString = string;

export interface UpdateWorkingHourDTO {
  id: string | null; // Guid
  dayOfWeek: DayOfWeek;
  openTime: TimeOnlyString;
  closeTime: TimeOnlyString;
  isClosed?: boolean;
  isOpen24Hours?: boolean;
}

export interface UpdateWorkingHourListDTO {
  workingHours: UpdateWorkingHourDTO[];
}

export interface CreateWorkingHourDTO {
  dayOfWeek: DayOfWeek;
  openTime: TimeOnlyString;
  closeTime: TimeOnlyString;
  isClosed?: boolean;
  isOpen24Hours?: boolean;
}

export interface CreateWorkingHourListDTO {
  workingHours: CreateWorkingHourDTO[];
}
